(function () {
    'use strict';
    angular.module('app').controller('newdoc', newdoc);
    newdoc.$inject = ['$location', '$filter', 'requiredFieldsService', '$scope', '$rootScope', 'gridDataService', '$q', 'SelectionCommand_WorkflowService', 'selectionCommandService', '$timeout', '$mdDialog', 'records', 'command', 'commandService', 'loginService', 'editEmailsService', 'zcs', 'workAreaService', 'extractionservice', 'autoNameService'];
    function newdoc($location, $filter, requiredFieldsService, scope, $rootScope, gridDataService, $q, SelectionCommand_WorkflowService, selectionCommandService, $timeout, $mdDialog, records, command, commandService, loginService, editEmailsService, zcs, workAreaService, extractionservice, autoNameService) {

        // =====================================
        // On Load.
        // =====================================

        // Initialize.
        scope.ACN_NEW = 135;
        scope.xyz = { autoNameMode: false, autoNameEnable: false, bReadyForOK: false, name: "", maxFileNameLength: -1, extension: "", docType: "", selectedFileTypeItem: null, workAreaId: "", selectedWorkAreaItem: null, selectedLibraryItem: null, docTypeRadio: "Unlinked Record", statusRadio: "New", gettingWorkAreaList: true };
        scope.processingLabel = loginService.resourceStrings["PROCESSING"];



        // Dialog config.
        scope.heading = loginService.resourceStrings["TITLE_NEWDOC"];
        scope.nameLabel = loginService.resourceStrings["NAME"];
        scope.extensionLabel = loginService.resourceStrings["EXTENSION"];
        scope.autoNameLabel = loginService.resourceStrings["AUTONAME"];
        scope.docTypeAppDescLabel = loginService.resourceStrings["DOC_TYPE_LABEL"];
        scope.workAreaLabel = loginService.resourceStrings["WORK_AREA"];
        scope.docTypeLabel = loginService.resourceStrings["DOC_TYPE_LABEL"];
        scope.statusLabel = loginService.resourceStrings["STATUS_LABEL"];
        scope.seriesLabel = loginService.resourceStrings["CREATE_SERIES_LABEL"];
        scope.seriesCheckboxLabel = loginService.resourceStrings["CREATE_SERIES_CHECKBOX_LABEL"];
        scope.OK = loginService.resourceStrings["OK"]; // "OK";
        scope.Cancel = loginService.resourceStrings["CANCEL"]; // "Cancel";
        scope.newLabel = loginService.resourceStrings["NEW"];
        scope.outFromLibraryLabel = loginService.resourceStrings["OUT_FROM_LIBRARY"];
        scope.documentLabel = loginService.resourceStrings["DOCUMENT"];
        scope.unlinkedRecordLabel = loginService.resourceStrings["UNLINKED_RECORD"];

        autoNameService.IsAutoNameEnabled().then(function (bEnabled) { scope.xyz.autoNameEnable = bEnabled; });

        scope.libraryArray = [];
        //scope.libraryArray.push({ id: '7a76d2b1-68a9-4d54-9c40-124c7fafd2d7', name: 'AFS-Checked' });
        //scope.libraryArray.push({ id: '0bdb13a6-c548-4262-a84a-a817f9263ec2', name: 'AFS-Unchecked' });
        //scope.libraryArray.push({ id: 'e62256c5-cad0-4c7d-aedd-adb6ad9b530e', name: 'AFS-Unchecked-AutoRev' });

        // Create a 'building list' item.
        var workAreaBuildingList = { workAreaId: 'building_list', name: "- " + loginService.resourceStrings["COMBO_BOX_BUILDING_LIST"] + " -" };
        // Add 'building list' to the array.
        scope.workAreaList = [];
        scope.workAreaList.push(workAreaBuildingList);
        // Select 'building list' in the combo.
        scope.xyz.selectedWorkAreaItem = workAreaBuildingList;

        // Load File Types.
        scope.fileTypesArray = [];
        selectionCommandService.getFileTypes().then(function (data) {
            angular.forEach(data, function (fileTypeInfoModel, itemNum) {
                scope.fileTypesArray.push({ id: fileTypeInfoModel.fileTypeId, name: fileTypeInfoModel.name, extension: fileTypeInfoModel.templateExtension })
            });

            // Load Work Areas.
            workAreaService.getWorkAreas().then(function (data) {

                var ValidationState_Valid = 1;
                data = data.filter(function (workAreaModel) {
                    return workAreaModel.validationState == ValidationState_Valid;
                });
                scope.workAreaList = data;

                scope.loadSettings();

                scope.xyz.gettingWorkAreaList = false;
            });
        }, function (response) {
            selectionCommandService.ShowEx(response);
        });

        selectionCommandService.GetMaxFilenameLength().then(function (data) {
            scope.xyz.maxFileNameLength = data;
            scope.xyz.maxFileNameOnlyLength = scope.xyz.maxFileNameLength;
        }, function (response) {
            selectionCommandService.ShowEx(response); // Nothing more to do.
        });

        // Ping ACS. On failure, close dialog.
        zcs.Ping(true).then(function (response) {
        }, function () {
            // Handle error.
            $mdDialog.hide();
            $rootScope.msgBoxShow(loginService.resourceStrings["ACS_FAILED_TO_CONNECT"], loginService.resourceStrings["ACS_REQUIRED"]);
        });

        scope.loadSettings = function () {
            // =======================
            // Load previous settings.
            // =======================
            if (selectionCommandService.fileNewSettings.statusRadio != null) {
                // workAreaId: commandParams.eWorkAreaId, statusRadio: scope.xyz.statusRadio, docTypeRadio: scope.xyz.docTypeRadio,  fileTypeId: commandParams.eFileTypeId, libId: commandParams.eLibId
                // Always use current work area.
                //// Pick last WA.
                //angular.forEach(scope.workAreaList, function (workAreaItem) {
                //    if (workAreaItem.workAreaId == selectionCommandService.fileNewSettings.workAreaId) {
                //        scope.xyz.selectedWorkAreaItem = workAreaItem;
                //    }
                //});
                scope.xyz.statusRadio = selectionCommandService.fileNewSettings.statusRadio;
                scope.xyz.docTypeRadio = selectionCommandService.fileNewSettings.docTypeRadio;
                // Pick last file type.
                if (scope.xyz.docTypeRadio == 'Document') {
                    angular.forEach(scope.fileTypesArray, function (fileTypeItem) {
                        if (fileTypeItem.id == selectionCommandService.fileNewSettings.fileTypeId) {
                            scope.xyz.selectedFileTypeItem = fileTypeItem;
                        }
                    });
                }
                // Library
                if (scope.xyz.statusRadio == 'Out from Library') {
                    scope.xyz.selectedLibraryItem = selectionCommandService.fileNewSettings.libItem;
                    scope.selectedLibraryName = selectionCommandService.fileNewSettings.libItem.name;
                }

                scope.statusChanged();
                scope.selectedFileTypeChanged();
                scope.docTypeChanged();
            }
            // Always use current work area.else {
            // Default to the current work area.
            if (workAreaService.currentWorkArea != null) {
                angular.forEach(scope.workAreaList, function (workAreaItem) {
                    if (workAreaItem.workAreaId == workAreaService.currentWorkArea.workAreaId) {
                        scope.xyz.selectedWorkAreaItem = workAreaItem;
                    }
                });
            }
            //}
        }


        //
        // Enables.
        //
        scope.doEnables = function () {
            var bReadyForOK = false;

            scope.xyz.maxFileNameOnlyLength = scope.xyz.maxFileNameLength - scope.xyz.extension.length;

            if (scope.xyz.name.length > 0 && scope.xyz.selectedWorkAreaItem != null && scope.xyz.selectedWorkAreaItem.name.length > 0) {
                if (scope.xyz.statusRadio == "New") {
                    if (scope.xyz.docTypeRadio != 'Document') {
                        bReadyForOK = true;
                    }
                    else {
                        if (scope.xyz.selectedFileTypeItem != null && scope.xyz.selectedFileTypeItem.name.length > 0) {
                            bReadyForOK = true;
                        }
                    }
                }
                else { // Out from Library
                    if (scope.xyz.selectedLibraryItem != null && scope.xyz.selectedLibraryItem.name.length > 0 && !scope.xyz.selectedLibraryItem.bIsFolder) {
                        console.log(scope.xyz.selectedLibraryItem);
                        if (scope.xyz.docTypeRadio != 'Document') {
                            bReadyForOK = true;
                        }
                        else {
                            if (scope.xyz.selectedFileTypeItem != null && scope.xyz.selectedFileTypeItem.name.length > 0) {
                                bReadyForOK = true;
                            }
                        }
                    }
                }
            }

            if (scope.xyz.name.length > scope.xyz.maxFileNameOnlyLength) {
                //scope.xyz.errMsg = loginService.resourceStrings["GATEKEEPER_REASON_TOOLONG"];
                scope.nameLabel = loginService.resourceStrings["NAME"] + " - " + loginService.resourceStrings["GATEKEEPER_REASON_TOOLONG"];
                bReadyForOK = false;
            }
            else {
                scope.nameLabel = loginService.resourceStrings["NAME"];  //scope.xyz.errMsg = "";
            }

            // Handle enabling OK.
            scope.xyz.bReadyForOK = bReadyForOK;
        }

        // =====================================
        // User interaction.
        // =====================================

        scope.onFilenameChanged = function () {

            // Strange. Angular fires onFilenameChanged with an 'undefined' value for scope.xyz.name
            // I'm probably missing something rather than it being an angular bug, but meanwhile
            // I'm going to work around with a save and restore.
            if (scope.xyz.name == null)
                scope.xyz.name = scope.xyz.hold_name;

            scope.doEnables();
        }

        // User picked a new File Type (Excel, Word).
        scope.selectedFileTypeChanged = function () {
            if (scope.xyz.selectedFileTypeItem == null)
                scope.xyz.extension = "";
            else
                scope.xyz.extension = scope.xyz.selectedFileTypeItem.extension;

            scope.doEnables();

            // Strange. Angular fires onFilenameChanged with an 'undefined' value for scope.xyz.name
            // I'm probably missing something rather than it being an angular bug, but meanwhile
            // I'm going to work around with a save and restore.
            scope.xyz.hold_name = scope.xyz.name;
        }

        // User picked a different Work Area.
        scope.selectedWorkAreaChanged = function () {
            scope.doEnables();
        }

        // User picked a new document type (Document, Unlinked Record).
        scope.docTypeChanged = function () {
            if (scope.xyz.docTypeRadio != "Document") {
                scope.xyz.selectedFileTypeItem = null;
                scope.xyz.extension = "";
            }

            scope.doEnables();
        }

        // User picked a new status (Out from Library, New).
        scope.statusChanged = function () {
            // 2018-04-11 Don't blank the selected library.
            //if (scope.xyz.statusRadio == "New")
            //    scope.xyz.selectedLibraryItem = null;

            scope.doEnables();
        }

        scope.selectedLibraryName = "";
        scope.selectedLibraryChanged = function (name, id, item) {
            if (item == null)
                scope.xyz.selectedLibraryItem = null;
            else
                scope.xyz.selectedLibraryItem = item;
            scope.doEnables();
            console.log(item);
        }

        scope.onNewDocDialogAutoName = function () {
            var deferred = $q.defer();
            $mdDialog.show({
                controller: 'autoNameDialog',
                templateUrl: 'app/autoname/autoNameDialog.html',
                parent: angular.element(document.body),
                clickOutsideToClose: false,
                fullscreen: false,
                skipHide: true,
                locals: {
                    defaultExtension: scope.xyz.extension,
                    numberOfDocuments: 1
                }
            })
                .then(function () {
                    // OK
                    if ($rootScope.dlgReturn != null && $rootScope.dlgReturn.autoNameOK == true) {
                        scope.xyz.name = $rootScope.dlgReturn.autoNameList[0]; //only one is currently requested for file new
                        scope.xyz.autoNameMode = true;
                        scope.doEnables();
                    }
                    deferred.resolve();
                }, function () {
                    //cancel
                    deferred.reject();
                });
            return deferred.promise;
        }


        // =====================================
        // OK, Cancel.
        // =====================================

        var handleResults = function (workAreaSI, autoNameFormatModel, selectionCommandResults) {
            var deferred = $q.defer();
            // Handle errors.
            var atLeastOneError = false;

            var slx = selectionCommandResults.slx;
            angular.forEach(slx.list, function (item) {
                if (atLeastOneError == false) {
                    if (item.ec != 0) {
                        atLeastOneError = true;
                        if (atLeastOneError) {
                            commandService.launchErrors({ slx: slx });
                            deferred.reject();
                        }
                    }
                }
            });

            zcs.ProcessFileOperationPacket(selectionCommandResults.fileOperationPacket, true).then(function (response) {
                //Perform an extraction for NEW items on return (GT)
                if (scope.xyz.docTypeRadio == 'Document') {
                    if (!scope.xyz.autoNameMode) {
                        // Not AutoName so run extraction
                        //Assign extraction item property values
                        extractionservice.extractionItem.tableNumber = slx.list[0].workAreaSI.tableNumber;
                        extractionservice.extractionItem.filePNE = scope.xyz.selectedWorkAreaItem.path + slx.list[0].commandParams.eNewName;
                        extractionservice.extractionItem.libId = slx.list[0].commandParams.eLibId;
                        extractionservice.extractionItem.fileId = slx.list[0].workAreaSI.fileId;
                        extractionservice.extractionItem.fileMajRev = slx.list[0].workAreaSI.majRev;
                        extractionservice.extractionItem.fileMinRev = slx.list[0].workAreaSI.minRev;

                        //promise to do the extraction for the new doc, on return update grid and show emails dialog
                        extractionservice.extractItem(extractionservice.extractionItem, true).then(function (response) {
                            $mdDialog.hide();
                            scope.xyz.processing = false;
                            //2018 SP1 Refactor: 20180830 - GT
                            //release plugin applications after extraction 
                            extractionservice.releasePluginApplications();

                            gridDataService.updateGridRecords(slx.list);
                            editEmailsService.showEditEmailsDialog(selectionCommandResults.emails);
                            deferred.resolve(slx.list[0]);
                        }, function (error) {
                            //there was an error with extractItem; close dialog and show error 
                            $mdDialog.hide();
                            selectionCommandService.ShowEx(error);
                            scope.xyz.processing = false
                            deferred.reject(error);
                        });
                    }
                    else {
                        // Call AutoName UpdateDocument instead of running extraction.
                        autoNameService.UpdateDocument(workAreaSI, autoNameFormatModel, workAreaSI.filename).then(function () {
                            $mdDialog.hide();
                            scope.xyz.processing = false;

                            gridDataService.updateGridRecords(slx.list);
                            editEmailsService.showEditEmailsDialog(selectionCommandResults.emails);
                            deferred.resolve(slx.list[0]);
                        }, function (error) {
                            //there was an error with extractItem; close dialog and show error 
                            $mdDialog.hide();
                            selectionCommandService.ShowEx(error);
                            scope.xyz.processing = false
                        });
                    }
                }
                else {
                    //non-document items require no extraction
                    $mdDialog.hide();
                    scope.xyz.processing = false;
                    gridDataService.updateGridRecords(slx.list);
                    editEmailsService.showEditEmailsDialog(selectionCommandResults.emails);
                    deferred.resolve(slx.list[0]);
                }
            }, function (response) {
                //there was an error with ProcessFileOperationPacket
                selectionCommandService.ShowEx(response); scope.xyz.processing = false;
                deferred.reject();
            });

            return deferred.promise;
        }

        var callNewDoc = function (slx, autoNameFormatModel) {
            var deferred = $q.defer();
            // Execute.
            selectionCommandService.newDoc(slx).then(function (response) {
                var selectionCommandResults = response.data;

                var fileId = "";
                if (selectionCommandResults != null && selectionCommandResults.slx != null && selectionCommandResults.slx.list != null && selectionCommandResults.slx.list.length > 0) {
                    var item = selectionCommandResults.slx.list[0];
                    if (item.workAreaSI != null) {
                        fileId = item.workAreaSI.fileId;
                    }
                    if (!scope.xyz.autoNameMode) {
                        handleResults(item.workAreaSI, autoNameFormatModel, selectionCommandResults).then(function (result) {
                            deferred.resolve(item.workAreaSI);
                        }, function () {
                            deferred.reject();
                        });
                    }
                    else {
                        autoNameService.AutoNameUpdateRecord(item.workAreaSI, autoNameFormatModel).then(function () {
                            handleResults(item.workAreaSI, autoNameFormatModel, selectionCommandResults).then(function (result) {
                                deferred.resolve(item.workAreaSI);
                            }, function () {
                                deferred.reject();
                            });
                        }, function (response) {
                            selectionCommandService.ShowEx(response); scope.xyz.processing = false;
                            deferred.reject();
                        });
                    }
                }

            }, function (response) {
                selectionCommandService.ShowEx(response); scope.xyz.processing = false;
                deferred.reject();
            });

            return deferred.promise;
        }

        scope.onNewDocDialogOK = function () {
            scope.xyz.processing = true;

            processNewDoc().then(function (result) {
            });

        };

        function processNewDoc() {

            var deferred = $q.defer();
            // Add 1 item to the list
            var items = [];
            var commandParams = {};
            commandParams.eNewName = scope.xyz.name + scope.xyz.extension;
            commandParams.eWorkAreaId = scope.xyz.selectedWorkAreaItem.workAreaId;
            commandParams.eFileTypeId = "";
            if (scope.xyz.selectedFileTypeItem != null)
                commandParams.eFileTypeId = scope.xyz.selectedFileTypeItem.id;
            commandParams.eLibId = "";
            // Only consider library if "Out from Library".
            if (scope.xyz.statusRadio != "New") {
                if (scope.xyz.selectedLibraryItem != null)
                    commandParams.eLibId = scope.xyz.selectedLibraryItem.libId;
            }
            var selectionItem = {
                commandParams: commandParams,
            };
            items.push(selectionItem);
            var slx = { mode: 0, order: 0, list: items };


            //ACS_REQUIRED

            // ==============
            // Save Settings
            // ==============
            selectionCommandService.fileNewSettings = { workAreaId: null, fileTypeId: null, libItem: null, statusRadio: scope.xyz.statusRadio, docTypeRadio: scope.xyz.docTypeRadio };
            // WA should never be null.
            if (scope.xyz.selectedWorkAreaItem.workAreaId != null)
                selectionCommandService.fileNewSettings.workAreaId = scope.xyz.selectedWorkAreaItem.workAreaId;
            if (scope.xyz.selectedFileTypeItem != null)
                selectionCommandService.fileNewSettings.fileTypeId = scope.xyz.selectedFileTypeItem.id;
            if (scope.xyz.selectedLibraryItem != null)
                selectionCommandService.fileNewSettings.libItem = scope.xyz.selectedLibraryItem;

            zcs.isDirectory(scope.xyz.selectedWorkAreaItem.path).then(function (response) {
                if (!response) {
                    scope.xyz.processing = false;
                    $rootScope.msgBoxShow(loginService.resourceStrings["WORK_AREA_ACCESS"], "");
                    deferred.reject();
                    return;
                }

                // This dialog has the WorkArea combo be a global. 
                // It is not applied to the row in the grid when it changes.
                var filePNE = scope.xyz.selectedWorkAreaItem.path + "\\" + commandParams.eNewName;

                // Collision check - local.
                zcs.isFile(filePNE, true).then(function (response) {
                    var bExistsLocally = response;
                    // Dup check - server.
                    //newDocService.NewDocDupCheck({ filename: commandParams.eNewName, workAreaId: commandParams.eWorkAreaId, libId: commandParams.eLibId, bExistsLocally: bExistsLocally }).then(function (response) {
                    selectionCommandService.CollisionCheck(scope.ACN_NEW, "", commandParams.eNewName, commandParams.eLibId, commandParams.eWorkAreaId, bExistsLocally).then(function (response) {
                        // If there was a collision, put up an error.
                        var collisionCheckResponse = response.data;
                        if (collisionCheckResponse.ec != 0) {
                            $rootScope.msgBoxShow(collisionCheckResponse.errStr, "");
                            scope.xyz.processing = false;
                            deferred.reject();
                        }
                        else {
                            if (!scope.xyz.autoNameMode) {
                                callNewDoc(slx, null).then(function (result) {
                                    deferred.resolve(result);
                                });
                            }
                            else {
                                autoNameService.GenerateAutoName($rootScope.dlgReturn.autoNameFormatModel).then(function (response) {
                                    var autoNameFormatModel = response.data;
                                    slx.list[0].commandParams.eNewName = autoNameFormatModel.generatedName + scope.xyz.extension;
                                    callNewDoc(slx, autoNameFormatModel).then(function (result) {
                                        deferred.resolve(result);
                                    }, function () {
                                        deferred.reject();
                                    });
                                }, function (response) {
                                    selectionCommandService.ShowEx(response); scope.xyz.processing = false;
                                    deferred.reject();
                                });
                            }

                        }
                    }, function (response) {
                        selectionCommandService.ShowEx(response); scope.xyz.processing = false;
                        deferred.reject();
                    });
                }, function (response) {
                    selectionCommandService.ShowEx(response); scope.xyz.processing = false;
                    deferred.reject();
                });
            });

            return deferred.promise;
        }

        scope.onNewDocDialogCancel = function () {
            // Close dialog.
            $mdDialog.hide();
        };
    }
})();
